export const deviceSize = {
  mobile: 'Mobile',
  computer: 'Computer',
  tablet: 'Tablet'
};

export const supportedAttachmentTypes = {
  image: ['jpg', 'jpeg', 'png', 'gif'],
  svg: ['svg'],
  pdf: ['pdf'],
  excel: ['xls', 'xlsx'],
  ppt: ['ppt', 'pptx'],
  doc: ['doc', 'docx'],
  video: ['mp4'],
  corel: ['ai', 'eps'],
  zip: ['zip']
};

export const confirmationCodes = {
  confirm: 'confirm'
};

export const defaultThumbnail = {
  name: 'default'
};

export const httpStatusCodes = {
  ok: 200,
  created: 201,
  badRequest: 400,
  notAuthenticated: 401,
  forbidden: 403,
  notFound: 404,
  invalidData: 422,
  internalServerError: 500
};

export const EVENT_STATUS_MAP = {
  PUBLISHED: 2,
  COMPLETED: 3,
  CANCELLED: 4,
  IN_PREVIEW: 5
};

export const registrationStatuses = {
  toBeInvited: 'TBIN',
  completed: 'COMP',
  reserved: 'RESV',
  confirmed: 'CONF',
  cancelled: 'CANC',
  registered: 'REG',
  invited: 'INVI',
  waitingCancelled: 'WCAN',
  notCompleted: 'NCOMP'
};

export const bookingStatus = {
  successful: 'Green',
  waitingList: 'Yellow',
  decline: 'Red'
};

export const bookingStatusIds = {
  1: 'Open',
  2: 'Closed',
  3: 'Cancelled',
  4: 'Declined',
  5: 'In progress'
};

export const iltPricesTypeKey = {
  standardPrice: 'STANDARD',
  advertisingSubsidy: 'ADVERTISING_SUBSIDY'
};

export const iltPricesCurrency = {
  eur: 'EUR'
};

export const metricTypes = {
  minutes: 1,
  hours: 2,
  days: 3,
  weeks: 4,
  months: 5,
  years: 6
};

export const steps = {
  back: 'back',
  next: 'next',
  skip: 'skip'
};

export const courseSessionType = {
  classroom: 'CLASSROOM',
  webinar: 'WEBINAR'
};

export const bookingRole = {
  manager: 'manager',
  learner: 'learner',
  trainer: 'trainer',
  admin: 'admin',
  teamAdmin: 'team admin',
  locationResponsible: 'location responsible'
};

export const days = {
  three: 3,
  four: 4
};

export const PAGE_SIZE_OPTIONS = Object.freeze([5, 10, 15, 20, 100]);

export const VISIBLE_TO_PUBLIC_FILTER = {
  key: 'visibleToPublic',
  operation: 'is',
  value: 'true'
};

export const ADDRESS_OPTIONS = {
  noAlternative: 'noAlternative',
  alternative: 'alternative'
};
export const MAIL_REGEX = /@[^.]*\./;
export const PHONE_REGEX = /^[0-9+()./ -]+$/; // Accepts only numbers with special characters ()/+.-
export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

export const PhoneTypes = {
  MOBILE: 1,
  HOME: 2,
  WORK: 3,
  FAX: 4,
  OTHER: 5
};

export const AddressTypes = {
  HOME: 1,
  SHIPPING: 2,
  BILLING: 3,
  BUSINESS: 4,
  RECIPIENT: 5
};

export const EmailTypes = {
  PERSONAL: 1,
  WORK: 2,
  OTHER: 3
};
